import React from 'react';

export const MuseumDetail = ({ data }) => (
  <>
    <div className="tour-detail__title-block">
      <div className="tour-detail__title-text">{data.fcltyNm || '-'}</div>
      <div className="tour-detail__title-tag">{data.fcltyNm.includes('미술관') ? '미술관' : '박물관'}</div>
    </div>
    
    <div className="tour-detail__info-text">정보</div>
    
    <div className="tour-detail__detail-block">
      <img className="tour-detail__detail-icon" src="icons/icon_address.svg" />
      <div className="tour-detail__detail-text">{data.rdnmadr || '-'}</div>
    </div>

    <div className="tour-detail__detail-block">
      <img className="tour-detail__detail-icon" src="icons/icon_phone.svg" />
      <div className="tour-detail__detail-text">{data.phoneNumber || '-'}</div>
    </div>

    <div className="tour-detail__detail-block">
      <img className="tour-detail__detail-icon" src="icons/icon_opentime.svg" />
      <div className="tour-detail__detail-text">
        평일 : {data.weekdayOperOpenHhmm || '-'}-{data.weekdayOperColseHhmm || '-'}<br/>
        공휴일 : {data.holidayOperOpenHhmm || '-'}-{data.holidayCloseOpenHhmm || '-'}<br/>
        휴관일 : {data.rstdeInfo || '-'}
      </div>
    </div>

    <div className="tour-detail__detail-block">
      <img className="tour-detail__detail-icon" src="icons/icon_homepage.svg" />
      <div className="tour-detail__detail-text">{data.homepageUrl || '-'}</div>
    </div>

    <div className="tour-detail__detail-block">
      <img className="tour-detail__detail-icon" src="icons/icon_price.svg" />
      <div className="tour-detail__detail-text">
        성인 : {data.adultChrge || '-'}원<br/>
        청소년 : {data.yngbgsChrge || '데이터가 없습니다'}원<br/>
        어린이 : {data.childChrge || '데이터가 없습니다'}원<br/>
        기타 : {data.etcChrgeInfo || '데이터가 없습니다'}
      </div>
    </div>

    <div className="tour-detail__detail-block">
      <img className="tour-detail__detail-icon" src="icons/icon_introduce.svg" />
      <div className="tour-detail__detail-text">소개 : {data.fcltyIntrcn || '데이터가 없습니다'}</div>
    </div>

    <div className="tour-detail__detail-block">
      <img className="tour-detail__detail-icon" src="icons/icon_type.svg" />
      <div className="tour-detail__detail-text">구분: {data.fcltyType || '데이터가 없습니다'}</div>
    </div>

    <div className="tour-detail__map-buttons">
      <a href={`https://map.kakao.com/link/map/${data.fcltyNm},${data.latitude},${data.longitude}`} target="_blank" rel="noopener noreferrer">
        <img className="tour-detail__kakao-map-button" src="/icons/btn_kakao_map.svg" alt="카카오맵" />
      </a>
      {/* <a href={`https://map.naver.com/v5/search/${data.fcltyNm}?c=/${data.longitude},${data.latitude}`} target="_blank" rel="noopener noreferrer">
        <img className="tour-detail__naver-map-button" src="/icons/btn_naver_map.svg" alt="네이버맵" />
      </a> */}
    </div>
  </>
);